const colors = require("tailwindcss/colors");

/** @type {import('tailwindcss').Config} */
module.exports = {
  content: ["./src/**/*.{js,ts,jsx,tsx}"],
  theme: {
    fontFamily: {
      "sans-regular": ["FavoritNormal", "ui-sans-serif", "system-ui"],
      "sans-book": ["FavoritBook", "ui-sans-serif", "system-ui"],
      "sans-light": ["FavoritLight", "ui-sans-serif", "system-ui"],
      sans: ["FavoritNormal", "ui-sans-serif", "system-ui"],
      mono: ["IBMPlexRegular", "ui-monospace", "monospace", "system-ui"],
    },
    extend: {
      colors: {
        transparent: "transparent",
        succinct: {
          blue: "#0E283D",
          black: "#050E16",
          white: "#FFFFFF",
          teal: "#C3DFE0",
          "teal-5": "#0F1820",
          "teal-10": "#18232A",
          "teal-20": "#2B383E",
          "teal-30": "#3E4D53",
          "teal-40": "#516267",
          "teal-50": "#64767B",
          "teal-60": "#778B8F",
          "teal-70": "#8AA0A3",
          "teal-80": "#9DB5B8",
          "teal-90": "#B0CACC",
          "teal-100": "#C3DFE0",
          neon: "#E8FE56",
          orange: "#FE6535",
        },
      },
      keyframes: {
        "pulse-dark": {
          "0%, 100%": { opacity: 1 },
          "50%": { opacity: 0 },
        },
        shimmer: {
          "100%": {
            transform: "translateX(100%)",
          },
        },
      },
      boxShadow: {
        "top-light": "0px 3px 0px #33296b, 0px 1px 15px rgba(0,0,0,.4)",
      },
      backgroundImage: {
        "purple-gradient":
          "linear-gradient( linear, left bottom, left top, color-stop(0, #3e2ba3), color-stop(1, #7463cb) )",
      },
    },
  },
  plugins: [],
};
